import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { SmsLoginPage } from '@/features/auth';

const smsLoginSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public/login/sms')({
  validateSearch: zodValidator(smsLoginSearchSchema),
  component: SmsLoginRouteComponent,
});

function SmsLoginRouteComponent() {
  const search = Route.useSearch();

  return <SmsLoginPage redirect={search.redirect} />;
}
